import gql from "graphql-tag";

export default gql`
  mutation DestroyPostReply($objectId: ID!) {
    destroyPostReply(objectId: $objectId)
  }
`;
